module.exports = __webpack_public_path__ + "static/media/mobile.c3c0b59d.png";